import React, { useRef, useState, useEffect } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

function EditorComponent(props) {
    const editorRef = useRef(null);
    const [isFocused, setIsFocused] = useState(false);
    const resizeTimeout = useRef(null);

    // Safe height adjustment with debounce

    const handleEditorChange = (event, editor) => {
        const data = editor.getData();
        props.onEditorChange(data);
        // adjustHeight(editor);
    };

    useEffect(() => {
        return () => clearTimeout(resizeTimeout.current);
    }, []);

    return (
        <div className={`editor-container ${props.className}`}>
            <CKEditor
                editor={ClassicEditor}
                data={props.value || props.data || ''}
                config={{
                    toolbar: ['bold', 'italic', 'link', 'bulletedList', 'numberedList'],
                    removePlugins: ['Height', 'Autoformat'] // Prevent conflicts
                }}
                onReady={(editor) => {
                    editorRef.current = editor;
                    // adjustHeight(editor);
                }}
                onChange={handleEditorChange}
                onFocus={(event, editor) => {
                    setIsFocused(true);
                }}
                onBlur={(event, editor) => {
                    setIsFocused(false);
                }}
            />
        </div>
    );
}

export default EditorComponent;